import useTrackedMutation, {
    UseTrackedMutationResult,
} from 'hooks/useTrackedMutation/index-deprecated';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type ToggleLicenseSuccessResponse = Api.Response.Success<
    Record<string, unknown>
>;

export type ToggleLicenseErrorResponse = Api.Response.Failure<string>;

export type ToggleLicenseResult = {mid: string};

export const usePostLicensingToggleLicense = (): UseTrackedMutationResult<
    ToggleLicenseSuccessResponse,
    ToggleLicenseErrorResponse,
    ToggleLicenseResult
> => {
    const locale = useLocale();

    return useTrackedMutation<
        ToggleLicenseSuccessResponse,
        ToggleLicenseErrorResponse,
        ToggleLicenseResult
    >((formData) =>
        request({
            formData,
            locale,
            method: 'POST', // cannot use PATCH due to Django configuration/limitations
            uri: '/licensing/toggle_license/',
        }),
    );
};
